<template>
  <PSidebar
    v-model:visible="statusSidebar"
    :base-z-index="$lg.config.zIndex.sidebar"
    :aria-close-label="$t_v2('43985', 'Fechar')"
    class="lg-aa-sidebar"
  >
    <div class="lg-aa-layout__conteudo__sidebar__container">
      <h4>{{ $store.state.layout.nomePortal }}</h4>
      <LGPanelMenu :menus="menu" />
    </div>

    <div v-if="produtos && produtos.length > 1" class="lg-aa-layout__conteudo__sidebar__container">
      <h4>{{ labelSecaoPorduto }}</h4>
      <LGPanelProduto :produtos="produtos" />
    </div>
  </PSidebar>
</template>

<script>
import PSidebar from 'primevue/sidebar';

import LGPanelMenu from 'lg-vue-components/panelMenu';
import LGPanelProduto from 'lg-vue-components/panelProduto';

export default {
  name: 'LGSidebar',
  components: {
    PSidebar,
    LGPanelMenu,
    LGPanelProduto,
  },
  props: {
    menu: {
      type: Array,
      required: true,
    },
    produtos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      labelSecaoPorduto: '',
    };
  },
  computed: {
    statusSidebar: {
      set(valor) {
        this.$store.commit('layout/setSidebarAtiva', valor);
      },
      get() {
        return this.$store.state.layout.statusSidebar;
      },
    },
  },
  mounted() {
    this.labelSecaoPorduto = this.$t_v2('5268', 'Produto');
  },
};
</script>
